import React, { Fragment } from 'react';
import { H3, H4, P, Image } from '../../../../AbstractElements';
import { InvoiceHash, IssuedJan, PaymentDue } from '../../../../Constant';
import { Col, Media, Row } from 'reactstrap';
import logo1 from '../../../../assets/images/other-images/logo-login.png';
import logo from '../../../../assets/images/logo/logo.png';

const InvoiceHeader = ({data, rowData}) => {

  // const createdDate = new Date(rowData.payment.map((t) => t.payment_updated_at));
  // console.warn(rowData.payment.map((t) => t?.payment_updated_at))
  //   // const formattedDate = createdDate.toISOString().split("T")[0];
  const paymentDates = rowData.payment
  .map((t) => t?.payment_updated_at)
  .filter((date) => date !== null && date !== undefined);

let formattedDate; // Declare formattedDate outside the if statement

if (paymentDates.length > 0) {
  const createdDate = new Date(paymentDates[0]); // Use the first valid date
  console.warn(paymentDates);
  formattedDate = createdDate.toISOString().split("T")[0]; // Assign formattedDate here
} else {
  console.warn("No valid payment dates found.");
  formattedDate = null; // Set formattedDate to null or any placeholder if needed
}

  return (
    <Fragment>
      <div className='d-flex justify-content-between'>
      {/* <Row className='invo-header'>
        <Col sm='6'> */}
          <Media>
            <div className='media-left'>
              <Image attrImage={{ className: 'media-object img-60', src: logo, alt: '' }} />
            </div>
            <Media body className='m-l-20 text-right'>
              <H4 attrH4={{ className: 'media-heading f-w-600' }}>Witte</H4>
              <P>
                witte@macincode.in
                <br />
                <span className='digits'>{'289-335-6503'}</span>
              </P>
            </Media>
          </Media>
        {/* </Col>
        <Col sm='6'> */}
          <div className='text-md-end'>
          {/* <div className='text-md-end  text-xs-center'> */}
            <H3>
              {InvoiceHash}
              {/* <span className='digits counter'>1069</span> */}
            </H3>
            <P>
              {"Issued : "}
              <span className='digits'> {formattedDate || "No valid payment found"}</span>
              <br />
              {/* {PaymentDue} <span className='digits'> 27, 2022</span> */}
            </P>
          </div>
        {/* </Col>
      </Row> */}
      </div>
      <hr />
    </Fragment>
  );
};
export default InvoiceHeader;
